import { render } from "./TestimonialTwo.vue?vue&type=template&id=bf2ab406"
import script from "./TestimonialTwo.vue?vue&type=script&lang=js"
export * from "./TestimonialTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__